
import React, { Component}  from 'react';
import _ from 'lodash';
import styled, { css } from 'styled-components';
import { grey } from "@material-ui/core/colors";
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { InputNumberWidget } from 'form/InputWidget';
import TariffPointServicesDrawer from "./PointServicesDrawer";


const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledTariffPointServiceForm = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 34px 1fr 120px 20px;
  margin-bottom: 20px;
  align-items: center;
  
  .tariffication_display {
    font-size: 12px;
    color: ${grey[700]};
  }
    
  ${props => !props.$isActive && css`
    color: ${grey[500]};
  `}
`;


class TariffPointServiceForm extends Component {

  removePointService = () => {
    const { context } = this.props;
    const index = this.findPointServiceIndex();
    if (index !== -1) {
      let point_service = context.item.tariff_points[index];
      if (point_service.id) {
        context.setValue(`tariff_points.${index}.cost`, 0);
        context.setValue(`tariff_points.${index}.is_delete`, true);
      }
      else {
        context.removeArrayValue(`tariff_points`, index);
      }
    }
  };

  findPointServiceIndex = () => {
    const { pointService, context } = this.props;
    return context.item.tariff_points.findIndex(
      o => o.service.id === pointService.service.id && o.point === pointService.point
    );
  };

  handleChange = (name, value) => {
    const { context } = this.props;
    const index = this.findPointServiceIndex();
    if (index !== -1) {
      context.setValue(`tariff_points.${index}.${name}`, value)
    }
  };

  render() {
    const { pointService, index } = this.props;
    const isServiceActive = pointService.service.is_active;
    return (
      <StyledTariffPointServiceForm
        $isActive={isServiceActive}
      >
        <div>
          <Index>{index + 1}</Index>
        </div>
        <div>
          <div>{pointService.service.label}</div>
          <div className={'tariffication_display mt-2'}>
            {pointService.service.tariffication_display}
            {', '}
            {pointService.service.financial_schema_display}
          </div>
        </div>
        <div>
          <InputNumberWidget
            value={pointService.cost}
            label={'Цена, ₽'}
            size={'small'}
            onChange={(value) => this.handleChange('cost', value)}
            disabled={!isServiceActive}
            InputLabelProps={{
              shrink: true
            }}
          />
        </div>
        <div>
          <IconButton tabIndex={'-1'} size={'small'} onClick={() => this.removePointService()}>
            <ClearIcon />
          </IconButton>
        </div>
      </StyledTariffPointServiceForm>
    )
  }
}


export class TariffPointServicesForm extends Component {

  getTariffPointsByPoint = (pointId) => {
    const { context } = this.props;
    return _.filter(context.item.tariff_points, function(o) {
      return o.point === pointId && !o.is_delete;
    });
  };

  render() {
    const { point } = this.props;
    const tariffPoints = this.getTariffPointsByPoint(point.id);

    return (
      <TariffPointServicesDrawer
        point={point}
        tariffPoints={tariffPoints}
        TariffPointServiceForm={TariffPointServiceForm}
      />
    )
  }
}
